import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { baseurl } from '../utility/helper';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Swal from 'sweetalert2';


function Home() {
  const roleid = parseInt(sessionStorage.getItem("CandidateID"));
  const Member_count = sessionStorage.getItem("members_in_india");
  const Total_member = sessionStorage.getItem("total_member");
  const [counters, setCounters] = useState([]);
  const [magazine, setMagazine] = useState(null);
  // console.log(Member_count);
  const [newsEvents, setNewsEvents] = useState([]);
    const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000, // Adjust autoplay speed as needed
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />
  };


  function PrevArrow(props) {
    const { onClick } = props;
    return (
      <button className="slick-prev" onClick={onClick}>
        Previous
      </button>
    );
  }

  function NextArrow(props) {
    const { onClick } = props;
    return (
      <button className="slick-next" onClick={onClick}>
        Next
      </button>
    );
  }

  useEffect(() => {
    const fetchMagazine = async () => {
      try {
        const res = await axios.get(`${baseurl}/magazines/latest`); // your backend URL
        setMagazine(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchMagazine();
  }, []);

  useEffect(() => {
    fetchCounters();
  }, []);

  const fetchCounters = async () => {
    try {
      const res = await axios.get(`${baseurl}/getCounters`);
      const data = res.data;

      setCounters(res.data);

      // Find "Members in India"
      const indiaMember = data.find(
        (item) => item.title === "Members in India"
      );
      const totalMember = data.find(
        (item) => item.title === "Total Members"
      );

      if (indiaMember) {
        sessionStorage.setItem(
          "members_in_india",
          indiaMember.value
        );
      }
      if (totalMember) {
        sessionStorage.setItem(
          "total_member",
          totalMember.value
        );
      }

    } catch (error) {
      console.error("Error fetching counters:", error);
    }
  };

  const settings2 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };


  const settings3 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1 
        }
      }
    ]
  };

  useEffect(() => {
    axios.get(`${baseurl}/news-events`)
        .then(response => setNewsEvents(response.data))
        .catch(error => console.error("Error fetching news:", error));
}, []);

  // useEffect(() => {
  //   const restaurantContainer = document.querySelector(".card-slider");
  //   const leftRButton = document.querySelector(".restaurant-arrow-left");
  //   const rightRButton = document.querySelector(".restaurant-arrow-right");

  //   function updateButtonState() {
  //     leftRButton.disabled = restaurantContainer.scrollLeft <= 0;
  //     rightRButton.disabled =
  //       restaurantContainer.scrollLeft + restaurantContainer.offsetWidth >=
  //       restaurantContainer.scrollWidth;
  //   }

  //   leftRButton.onclick = function () {
  //     restaurantContainer.scrollBy({
  //       left: -restaurantContainer.offsetWidth / 2,
  //       behavior: "smooth",
  //     });
  //   };

  //   rightRButton.onclick = function () {
  //     restaurantContainer.scrollBy({
  //       left: restaurantContainer.offsetWidth / 2,
  //       behavior: "smooth",
  //     });
  //   };

  //   restaurantContainer.addEventListener("scroll", updateButtonState);
  //   updateButtonState();

  //   // Clean up function to remove event listener
  //   return () => {
  //     restaurantContainer.removeEventListener("scroll", updateButtonState);
  //   };
  // }, []); 
  const bufferToBase64 = (buffer) => {
    if (!buffer || !buffer.data) return null;
    const binary = new Uint8Array(buffer.data).reduce(
      (acc, byte) => acc + String.fromCharCode(byte),
      ''
    );
    return `data:image/png;base64,${btoa(binary)}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      name: e.target.name.value,
      phone: e.target.phone.value,
      email: e.target.email.value,
      message: e.target.message.value,
    };

    try {
      const response = await axios.post(
        `${baseurl}/candidate-enquiry`,
        formData
      );

      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Enquiry sent successfully",
        });

        e.target.reset();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to send enquiry",
      });
    }
  };

  const handleViewPDF = async (id) => {
    try {
      const res = await axios.get(`${baseurl}/magazines/download?id=${id}`);
      const files = res.data.files;

      files.forEach(file => {
        const link = document.createElement("a");
        link.href = file.url;     // presigned URL
        link.download = file.filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    } catch (err) {
      console.error(err);
      alert("Failed to download PDF");
    }
  };
  
  
  return (

    <div>



<section className="banner">
  <Slider {...settings}>

    {/* Slide 1 - Clean Image */}
    <div className="hero-slide">
      <img src="assets/img/herobanner.png" alt="Banner 1" />
       <div className="hero-content">
        <h1 className="hero-title">
          THE SOCIETY 
          <br />
          OF HIGH IQ PEOPLE
        </h1>
        <p className="hero-subtitle">
          Mensa is the largest and oldest high IQ society in the
          world. It is a non-profit organization open to people who
          score at the 98th percentile or higher on a standardised,
          supervised IQ or other approved intelligence test.
        </p>
       <p className="hero-title" style={{margin:'0'}}>{Member_count}</p>
      </div>
    </div>

    {/* Slide 2 - Text + Button */}
    <div className="hero-slide">
      <img src="assets/img/herobanner3.png" alt="Social Impact" />
      <div className="hero-content">
        <h1 className="hero-title">
          SOCIAL IMPACT
          <br />
          DHRUV &amp; TMNP
        </h1>
       
        <div className="hero-actions">
          <NavLink to="/Spotlight" className="hero-btn hero-btn--primary"> Click Here</NavLink>
        </div>
      </div>
    </div>

    {/* Slide 3 - Text + Button */}
    <div className="hero-slide">
      <img src="assets/img/herobanner.png" alt="Our Mission" />
      <div className="hero-content">
        <h1 className="hero-title">
          THE SOCIETY 
          <br />
          OF HIGH IQ PEOPLE
        </h1>
        <p className="hero-subtitle">
          Mensa is the largest and oldest high IQ society in the
          world. It is a non-profit organization open to people who
          score at the 98th percentile or higher on a standardised,
          supervised IQ or other approved intelligence test.
        </p>
       <p className="hero-title" style={{margin:'0'}}>{Member_count}</p>
      </div>
    </div>

  </Slider>
</section>
    
  <main id="main">
 
  <section id="features" className="features">
      <div className="container">

        <div className="row">
          <div className="col-md-6  ">
           <div className="row">
            {counters.map((item, index) => {
                    // Dynamic class name
                    let counterClass = "counter";
                    if (index === 1) counterClass = "counter2 blue";
                    if (index === 2) counterClass = "counter3 blue";
                    if (index === 3) counterClass = "counter0 blue";

                    return (
                      <div className="col-md-6 newrow" key={item.id}>
                        <div className={counterClass}>
                          <span className="counter-value">
                            {item.value}
                          </span>
                          <h3>{item.title}</h3>
                        </div>
                      </div>
                    );
            })}
        </div>
        </div>
        
          <div className="col-md-6 col-lg-6 order-1 order-lg-2" data-aos="zoom-in">
            <div className="tab-content">
              <div className="tab-pane active show" id="tab-1">
                <figure>
                  <h1>About Us:</h1>
                <p id="typed-text"><strong>"Membership in India: {Member_count} "</strong>
Mensa, an international high-IQ society, boasts a diverse membership with over {Total_member} individuals across the world and more than 100 countries globally. Founded in 1946, Mensa aims to provide a forum for intellectual exchange among its members, who have demonstrated exceptional intelligence through standardized IQ tests.</p>

<h1>IQ:</h1>

<p  id="typed-text"> The organization offers a unique platform for individuals with high IQ scores, fostering a sense of community and enabling networking among like-minded individuals. Mensa conducts regular IQ tests to identify and admit members, ensuring a stimulating environment for those with exceptional cognitive abilities.


</p>
                <p id="typed-text1"></p>
                </figure>
              </div>
            </div>
          </div>

        </div>

      </div>
    </section>

    <section id="services" className="services section-bg">
      <div className="container">

        <div className="section-title" data-aos="fade-up">
          <h2>Joining Procedures</h2>
          <p></p>
        </div>

        <div className="row">
          <div className="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0" data-aos="zoom-in">
            <div className="icon-box icon-box-pink">
              <div className="icon"><i className="bx bx-file"></i></div>
              <h4 className="title"><a href="">Online Mensa Pre-Test</a></h4>
              <p className="description"  style={{height:'120px'}}>The Pre Test helps you understand if you are Mensa material from the comfort of your home.</p>
              <NavLink to="/JoinUs "  state={{ tab: "#five" }}>
                <button className="button-17 b17" role="button">Take the Pre-Test</button>
              </NavLink>
            </div>
           
          </div>

          <div className="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0" data-aos="zoom-in" data-aos-delay="100">
            <div className="icon-box icon-box-cyan">
              <div className="icon"><i className="bx bx-file"></i></div>
              <h4 className="title"><a href="">Book Your Test</a></h4>
              <p className="description" style={{height:'120px'}}>The Official Mensa India Test is conducted across locations. Click below to apply</p>
              <NavLink to="/JoinUs">
    <button className="button-17 b17" role="button">Apply Now</button>
  </NavLink>
            </div>
           
          </div>

          <div className="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0" data-aos="zoom-in" data-aos-delay="200">
            <div className="icon-box icon-box-green">
              <div className="icon"><i className="bx bx-file"></i></div>
              <h4 className="title"><a href="">Prior Evidence</a></h4>
              <p className="description" style={{height:'120px'}}>Mensa India has recently started accepting prior evidence based on approved standard intelligence tests.</p>
              
              <NavLink to="/JoinUs"><button className="button-17 b18" role="button">Know More and Submit</button></NavLink>  
            </div>
            
          </div>

         

        </div>

      </div>
    </section>

    <section id="about" className="about">
    <div className="container">

      <div className="row">
        <div className="col-lg-6" data-aos="zoom-in">
          <img src="assets/img/about.jpg" className="img-fluid" alt="" style={{borderRadius:'20px 20px 20px 130px'}}></img>
        </div>
        <div className="col-lg-6 d-flex flex-column justify-contents-center" data-aos="fade-left">
          <div className="content pt-4 pt-lg-0">
            <h3>What is IQ Challenge </h3>
            <p className="font-italic">
            "Mind Mastery: The IQ Challenge"
            </p>
            <ul>
              <li style={{textAlign:'justify'}}><i className="icofont-check-circled"></i>  "Unlocking Potential"
Embark on a journey of self-discovery as you delve into mind-bending puzzles and logical challenges, revealing the untapped depths of your intellectual prowess.</li>
              <li style={{textAlign:'justify'}}><i className="icofont-check-circled"></i>"Strategic Thinking"
Navigate through intricate scenarios that demand strategic thinking and quick decision-making, honing your ability to tackle complex problems with precision.</li>
              <li style={{textAlign:'justify'}}><i className="icofont-check-circled"></i>"The Genius Within"
Discover the genius within as the IQ Challenge concludes, offering insights into your cognitive strengths and providing a platform for continuous intellectual growth.</li>
            </ul>
            <p>
            
            </p>
          </div>
        </div>
      </div>

    </div>
  </section>


{/* 
  <section id="team" className="team">
    <div className="container">
        <div className="section-title" data-aos="fade-up">
            <h2>NEWS & EVENTS</h2>
        </div>
        <div className="row">
        <Slider {...settings3}>
            {newsEvents.map((event, index) => (
                <div className="eventlist">
                <div key={index} className="member" data-aos="zoom-in">
                    
                        <div className="pic">
                            <img 
                                src={event.image || "assets/img/portfolio/portfolio-1.jpg"} 
                                className="img-fluid" 
                                width={300}
                                height={250}
                                alt={event.title} 
                            />
                        </div>
                        <div className="event-info">
                            <h4>{event.title}</h4>
                            <p style={{fontSize:14}}>{event.short_desc}</p>
                            <a href="#" className="read-more">Read more &gt;</a>
                        </div>
                    </div>
                    </div>
            ))}
        </Slider>
        </div>
    </div>
</section> */}

<section id="team" className="team" style={{paddingBottom:'1px'}}>
    <div className="container">
        <div className="section-title" data-aos="fade-up" style={{paddingBottom:'1px'}}>
            <h2>NEWS & EVENTS</h2>
        </div>
        <Carousel
            responsive={{
                superLargeDesktop: { breakpoint: { max: 4000, min: 1024 }, items: 3 },
                desktop: { breakpoint: { max: 1024, min: 768 }, items: 2 },
                tablet: { breakpoint: { max: 768, min: 464 }, items: 1 },
                mobile: { breakpoint: { max: 464, min: 0 }, items: 1 }
            }}
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={2000}
            arrows={true}
        >
            {newsEvents.map((event, index) => (
                <div className="eventlist" key={index}>
                    <div className="member" data-aos="zoom-in">
                        <div className="pic">
                            <img 
                                src={bufferToBase64(event.main_image) || "assets/img/portfolio/portfolio-1.jpg"}
                                className="img-fluid" 
                                width={300}
                                alt={event.title} 
                                style={{height:'200px', objectFit:'contain'}}
                            />
                        </div>
                        <div className="event-info">
                            <h4>{event.title}</h4>
                            <p style={{fontSize: 14}}>{event.short_desc}</p>
                            <NavLink to="/Spotlight "  state={{ tab: "#two" }}>
                              <button className="btn btn-primary">
                                Read More
                              </button>
                          </NavLink>
                        </div>
                    </div>
                </div>
            ))}
        </Carousel>
    </div>
</section>


  



    {/* <section id="portfolio" className="portfolio">
      <div className="container">
      
        <div className="section-title" data-aos="fade-up">
          <h2>New & Events</h2>
          <p>"Elevate your mind with Mensa's IQ growth platform! Dive into challenging tests, cultivate intelligence, and join us for dynamic events that celebrate intellect and foster personal growth."</p>
        </div>

        <div className="row">
          <div className="col-lg-12 d-flex justify-content-center" data-aos="fade-up" data-aos-delay="100">
            <ul id="portfolio-flters">
              <li data-filter="*" className="filter-active">All</li>
              <li data-filter=".filter-app">App</li>
              <li data-filter=".filter-card">Card</li>
              <li data-filter=".filter-web">Web</li>
            </ul>
          </div>
        </div>

        <div className="row portfolio-container" data-aos="fade-up" data-aos-delay="200">

          <div className="col-lg-4 col-md-6 portfolio-item filter-app">
            <div className="portfolio-wrap">
              <img src="assets/img/portfolio/portfolio-2.jpg" className="img-fluid" alt=""></img>
              <div className="portfolio-info">
                <h4>Mensa India </h4>
                <p>Read More</p>
              </div>
              <div className="portfolio-links">
                <a href="assets/img/portfolio/portfolio-1.jpg" data-gall="portfolioGallery" className="venobox" title="App 1"><i className="bx bx-plus"></i></a>
                <a href="assets/img/portfolio/portfolio-2.jpg" title="More Details"><i className="bx bx-link"></i></a>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-web">
            <div className="portfolio-wrap">
              <img src="assets/img/portfolio/portfolio-2.jpg" className="img-fluid" alt=""></img>
              <div className="portfolio-info">
                <h4>Web 3</h4>
                <p>Web</p>
              </div>
              <div className="portfolio-links">
                <a href="assets/img/portfolio/portfolio-2.jpg" data-gall="portfolioGallery" className="venobox" title="Web 3"><i className="bx bx-plus"></i></a>
                <a href="" title="More Details"><i className="bx bx-link"></i></a>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-app">
            <div className="portfolio-wrap">
              <img src="assets/img/portfolio/portfolio-3.jpg" className="img-fluid" alt=""></img>
              <div className="portfolio-info">
                <h4>App 2</h4>
                <p>App</p>
              </div>
              <div className="portfolio-links">
                <a href="assets/img/portfolio/portfolio-3.jpg" data-gall="portfolioGallery" className="venobox" title="App 2"><i className="bx bx-plus"></i></a>
                <a href="" title="More Details"><i className="bx bx-link"></i></a>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-card">
            <div className="portfolio-wrap">
              <img src="assets/img/portfolio/portfolio-4.jpg" className="img-fluid" alt=""></img>
              <div className="portfolio-info">
                <h4>Card 2</h4>
                <p>Card</p>
              </div>
              <div className="portfolio-links">
                <a href="assets/img/portfolio/portfolio-4.jpg" data-gall="portfolioGallery" className="venobox" title="Card 2"><i className="bx bx-plus"></i></a>
                <a href="" title="More Details"><i className="bx bx-link"></i></a>
              </div>
            </div>
          </div>

          
        </div>

      </div>
    </section> */}

    


    {/* <section id="cta" className="cta">
      <div className="container">

        <div className="row" data-aos="zoom-in">
          <div className="col-lg-9 text-center text-lg-left">
            <h6>Call To Action</h6>
            <p> Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
          </div>
          <div className="col-lg-3 cta-btn-container text-center">
            <a className="cta-btn align-middle" href="#">Call To Action</a>
          </div>
        </div>

      </div>
    </section> */}

    
    {/* <section id="testimonials" className="testimonials">
      <div className="container">
        <div className="section-title" data-aos="fade-up">
          <h2>Success Stories</h2>
          <p>"Overcoming challenges, seizing opportunities, and achieving dreams - these success stories inspire and motivate with resilience, determination, and triumph."</p>
        </div>
        <div className="owl-carousel testimonials-carousel" data-aos="fade-up" data-aos-delay="100">
            <div className="icon-box icon-box-pink" style={{textAlign:'-webkit-center' }}>
            <div className="newimage"><img src="https://mensaindia.org/new/assets/img/trainers/sheetal.jpg" alt="Image"></img></div>

              <h4 className="title"><a href="">Sheetal Harpale</a></h4>
              <p className="description">
                   It's easy to communicate when you are with like minded people...afterall its difficult to find friends with same disorder 😜</p>
            </div>
          
            <div className="icon-box icon-box-pink" style={{textAlign:'-webkit-center' }}>
            <div className="newimage"><img src="https://mensaindia.org/new/assets/img/trainers/sheetal.jpg" alt="Image"></img></div>

              <h4 className="title"><a href="">Sheetal Harpale</a></h4>
              <p className="description">
                   It's easy to communicate when you are with like minded people...afterall its difficult to find friends with same disorder 😜</p>
             
            </div>
           
            <div className="icon-box icon-box-pink" style={{textAlign:'-webkit-center' }}>
            <div className="newimage"><img src="https://mensaindia.org/new/assets/img/trainers/sheetal.jpg" alt="Image"></img></div>

              <h4 className="title"><a href="">Sheetal Harpale</a></h4>
              <p className="description">
                   It's easy to communicate when you are with like minded people...afterall its difficult to find friends with same disorder 😜</p>
             
            </div>

        </div>
      </div>
    </section> */}

    

{/* <section id="services" className="services section-bg">
      <div className="container">

        <div className="section-title" data-aos="fade-up">
          <h2>Success Stories</h2>
          <p>=========================================================================================</p>
        </div>

        <div className="row">
          <div className="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0" data-aos="zoom-in">
            <div className="icon-box icon-box-pink">
              <div className="icon"><i className="bx bxl-dribbble"></i></div>
              <h4 className="title"><a href="">Nmae</a></h4>
              <p className="description">===============================================================================</p>
              
            </div>
           
          </div>

          <div className="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0" data-aos="zoom-in" data-aos-delay="100">
            <div className="icon-box icon-box-cyan">
              <div className="icon"><i className="bx bx-file"></i></div>
              <h4 className="title"><a href="">Nmae</a></h4>
              <p className="description">===============================================================================</p>
             
            </div>
           
          </div>

          <div className="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0" data-aos="zoom-in" data-aos-delay="200">
            <div className="icon-box icon-box-green">
              <div className="icon"><i className="bx bx-tachometer"></i></div>
              <h4 className="title"><a href="">Name</a></h4>
              <p className="description">===============================================================================</p>
              
            </div>
          </div>

        

        </div>

      </div>
    </section> */}
    {magazine && magazine.heading && (
          <section id="team" className="team">
          <div className="container">
            <div className="section-title" data-aos="fade-up" style={{paddingBottom:'1px'}}>
            <h2>MInd Magazine </h2>
        </div>

      <div className="row">
        <div className="col-lg-6" data-aos="zoom-in">
          <img src="assets/img/about.jpg" className="img-fluid" alt="" style={{borderRadius:'20px 20px 20px 130px'}}></img>
        </div>
        
        <div className="col-lg-6 d-flex flex-column justify-contents-center" data-aos="fade-left">
            <div className="content pt-4 pt-lg-0">
              <h3>{magazine?.heading}</h3>
              <p className="font-italic">{magazine?.short_desc}</p>
              <ul>
                {/* <li> */}
                  <i className="icofont-check-circled"></i> {magazine?.long_desc}
                {/* </li> */}
              </ul>
              <br />
                <NavLink to="/Spotlight "  state={{ tab: "#three" }}>
                    <button className="btn btn-primary">
                      Read More
                    </button>
                </NavLink>
                &nbsp;
                <button
                  className="btn btn-primary"
                  onClick={() => handleViewPDF(magazine.id)}
                >
                View
              </button>
            </div>
          </div>
      </div>
</div>
</section>
)}
    {/* <section id="team" className="team" style={{paddingTop:'10px'}}>
      <div className="container" style={{marginBottom:-50}}>

        <div className="section-title" data-aos="fade-up" >
          <h2>Testimonials</h2>
          <p></p>
        </div>

        <div className="row">

        <Slider {...settings2}>

          <div className="">
            <div className="member" data-aos="zoom-in">
              <div className="pic"><img src="assets/img/team/team-1.jpg" className="img-fluid" alt=""></img></div>
              <div className="member-info">
                <h4>Name Surname</h4>
                <span>Chief Executive Officer</span>
                
              </div>
            </div>
          </div>

          <div className="">
            <div className="member" data-aos="zoom-in" data-aos-delay="100">
              <div className="pic"><img src="assets/img/team/team-2.jpg" className="img-fluid" alt=""></img></div>
              <div className="member-info">
                <h4>Name Surname</h4>
                <span>Product Manager</span>
                
              </div>
            </div>
          </div>

          <div className="">
            <div className="member" data-aos="zoom-in" data-aos-delay="200">
              <div className="pic"><img src="assets/img/team/team-3.jpg" className="img-fluid" alt=""></img></div>
              <div className="member-info">
                <h4>Name Surname</h4>
                <span>CTO</span>
                 
              </div>
            </div>
          </div>

          <div className="">
            <div className="member" data-aos="zoom-in" data-aos-delay="100">
              <div className="pic"><img src="assets/img/team/team-2.jpg" className="img-fluid" alt=""></img></div>
              <div className="member-info">
                <h4>Name Surname</h4>
                <span>Product Manager</span>
                
              </div>
            </div>
          </div>

          </Slider>

        </div>

      </div>
    </section> */}



    {/* <section id="clients" className="clients">
      <div className="container">

        <div className="section-title" data-aos="fade-up">
          <h2>Clients</h2>
          <p>Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex aliquid fuga eum quidem. Sit sint consectetur velit. Quisquam quos quisquam cupiditate. Et nemo qui impedit suscipit alias ea. Quia fugiat sit in iste officiis commodi quidem hic quas.</p>
        </div>

        <div className="row no-gutters clients-wrap clearfix wow fadeInUp">

          <div className="col-lg-3 col-md-4 col-xs-6">
            <div className="client-logo" data-aos="zoom-in">
              <img src="assets/img/clients/client-1.png" className="img-fluid" alt=""></img>
            </div>
          </div>

          <div className="col-lg-3 col-md-4 col-xs-6">
            <div className="client-logo" data-aos="zoom-in" data-aos-delay="100">
              <img src="assets/img/clients/client-2.png" className="img-fluid" alt=""></img>
            </div>
          </div>

          <div className="col-lg-3 col-md-4 col-xs-6">
            <div className="client-logo" data-aos="zoom-in" data-aos-delay="150">
              <img src="assets/img/clients/client-3.png" className="img-fluid" alt=""></img>
            </div>
          </div>

          <div className="col-lg-3 col-md-4 col-xs-6">
            <div className="client-logo" data-aos="zoom-in" data-aos-delay="200">
              <img src="assets/img/clients/client-4.png" className="img-fluid" alt=""></img>
            </div>
          </div>

          <div className="col-lg-3 col-md-4 col-xs-6">
            <div className="client-logo" data-aos="zoom-in" data-aos-delay="250">
              <img src="assets/img/clients/client-5.png" className="img-fluid" alt=""></img>
            </div>
          </div>

          <div className="col-lg-3 col-md-4 col-xs-6">
            <div className="client-logo" data-aos="zoom-in" data-aos-delay="300">
              <img src="assets/img/clients/client-6.png" className="img-fluid" alt=""></img>
            </div>
          </div>

          <div className="col-lg-3 col-md-4 col-xs-6">
            <div className="client-logo" data-aos="zoom-in" data-aos-delay="350">
              <img src="assets/img/clients/client-7.png" className="img-fluid" alt=""></img>
            </div>
          </div>

          <div className="col-lg-3 col-md-4 col-xs-6" data-aos="zoom-in" data-aos-delay="400">
            <div className="client-logo">
              <img src="assets/img/clients/client-8.png" className="img-fluid" alt=""></img>
            </div>
          </div>

        </div>

      </div>
    </section> */}


    {/* <section id="pricing" className="pricing section-bg">
      <div className="container">

        <div className="section-title" data-aos="fade-up">
          <h2>Pricing</h2>
          <p>Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex aliquid fuga eum quidem. Sit sint consectetur velit. Quisquam quos quisquam cupiditate. Et nemo qui impedit suscipit alias ea. Quia fugiat sit in iste officiis commodi quidem hic quas.</p>
        </div>

        <div className="row">

          <div className="col-lg-3 col-md-6">
            <div className="box" data-aos="zoom-in">
              <h6>Free</h3>
              <h4><sup>$</sup>0<span> / month</span></h4>
              <ul>
                <li>Aida dere</li>
                <li>Nec feugiat nisl</li>
                <li>Nulla at volutpat dola</li>
                <li className="na">Pharetra massa</li>
                <li className="na">Massa ultricies mi</li>
              </ul>
              <div className="btn-wrap">
                <a href="#" className="btn-buy">Buy Now</a>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 mt-4 mt-md-0">
            <div className="box featured" data-aos="zoom-in" data-aos-delay="100">
              <h6>Business</h3>
              <h4><sup>$</sup>19<span> / month</span></h4>
              <ul>
                <li>Aida dere</li>
                <li>Nec feugiat nisl</li>
                <li>Nulla at volutpat dola</li>
                <li>Pharetra massa</li>
                <li className="na">Massa ultricies mi</li>
              </ul>
              <div className="btn-wrap">
                <a href="#" className="btn-buy">Buy Now</a>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 mt-4 mt-lg-0">
            <div className="box" data-aos="zoom-in" data-aos-delay="200">
              <h3>Developer</h3>
              <h4><sup>$</sup>29<span> / month</span></h4>
              <ul>
                <li>Aida dere</li>
                <li>Nec feugiat nisl</li>
                <li>Nulla at volutpat dola</li>
                <li>Pharetra massa</li>
                <li>Massa ultricies mi</li>
              </ul>
              <div className="btn-wrap">
                <a href="#" className="btn-buy">Buy Now</a>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 mt-4 mt-lg-0">
            <div className="box" data-aos="zoom-in" data-aos-delay="300">
              <span className="advanced">Advanced</span>
              <h3>Ultimate</h3>
              <h4><sup>$</sup>49<span> / month</span></h4>
              <ul>
                <li>Aida dere</li>
                <li>Nec feugiat nisl</li>
                <li>Nulla at volutpat dola</li>
                <li>Pharetra massa</li>
                <li>Massa ultricies mi</li>
              </ul>
              <div className="btn-wrap">
                <a href="#" className="btn-buy">Buy Now</a>
              </div>
            </div>
          </div>

        </div>

      </div>
    </section> */}



    {/* <section id="faq" className="faq">
      <div className="container">

        <div className="section-title" data-aos="fade-up">
          <h2>Frequently Asked Questions</h2>
        </div>

        <ul className="faq-list">

          <li data-aos="fade-up">
            <a data-toggle="collapse" className="" href="#faq1">Non consectetur a erat nam at lectus urna duis? <i className="icofont-simple-up"></i></a>
            <div id="faq1" className="collapse show" data-parent=".faq-list">
              <p>
                Feugiat pretium nibh ipsum consequat. Tempus iaculis urna id volutpat lacus laoreet non curabitur gravida. Venenatis lectus magna fringilla urna porttitor rhoncus dolor purus non.
              </p>
            </div>
          </li>

          <li data-aos="fade-up" data-aos-delay="100">
            <a data-toggle="collapse" href="#faq2" className="collapsed">Feugiat scelerisque varius morbi enim nunc faucibus a pellentesque? <i className="icofont-simple-up"></i></a>
            <div id="faq2" className="collapse" data-parent=".faq-list">
              <p>
                Dolor sit amet consectetur adipiscing elit pellentesque habitant morbi. Id interdum velit laoreet id donec ultrices. Fringilla phasellus faucibus scelerisque eleifend donec pretium. Est pellentesque elit ullamcorper dignissim. Mauris ultrices eros in cursus turpis massa tincidunt dui.
              </p>
            </div>
          </li>

          <li data-aos="fade-up" data-aos-delay="200">
            <a data-toggle="collapse" href="#faq3" className="collapsed">Dolor sit amet consectetur adipiscing elit pellentesque habitant morbi? <i className="icofont-simple-up"></i></a>
            <div id="faq3" className="collapse" data-parent=".faq-list">
              <p>
                Eleifend mi in nulla posuere sollicitudin aliquam ultrices sagittis orci. Faucibus pulvinar elementum integer enim. Sem nulla pharetra diam sit amet nisl suscipit. Rutrum tellus pellentesque eu tincidunt. Lectus urna duis convallis convallis tellus. Urna molestie at elementum eu facilisis sed odio morbi quis
              </p>
            </div>
          </li>

          <li data-aos="fade-up" data-aos-delay="300">
            <a data-toggle="collapse" href="#faq4" className="collapsed">Ac odio tempor orci dapibus. Aliquam eleifend mi in nulla? <i className="icofont-simple-up"></i></a>
            <div id="faq4" className="collapse" data-parent=".faq-list">
              <p>
                Dolor sit amet consectetur adipiscing elit pellentesque habitant morbi. Id interdum velit laoreet id donec ultrices. Fringilla phasellus faucibus scelerisque eleifend donec pretium. Est pellentesque elit ullamcorper dignissim. Mauris ultrices eros in cursus turpis massa tincidunt dui.
              </p>
            </div>
          </li>

          <li data-aos="fade-up" data-aos-delay="400">
            <a data-toggle="collapse" href="#faq5" className="collapsed">Tempus quam pellentesque nec nam aliquam sem et tortor consequat? <i className="icofont-simple-up"></i></a>
            <div id="faq5" className="collapse" data-parent=".faq-list">
              <p>
                Molestie a iaculis at erat pellentesque adipiscing commodo. Dignissim suspendisse in est ante in. Nunc vel risus commodo viverra maecenas accumsan. Sit amet nisl suscipit adipiscing bibendum est. Purus gravida quis blandit turpis cursus in
              </p>
            </div>
          </li>

          <li data-aos="fade-up" data-aos-delay="500">
            <a data-toggle="collapse" href="#faq6" className="collapsed">Tortor vitae purus faucibus ornare. Varius vel pharetra vel turpis nunc eget lorem dolor? <i className="icofont-simple-up"></i></a>
            <div id="faq6" className="collapse" data-parent=".faq-list">
              <p>
                Laoreet sit amet cursus sit amet dictum sit amet justo. Mauris vitae ultricies leo integer malesuada nunc vel. Tincidunt eget nullam non nisi est sit amet. Turpis nunc eget lorem dolor sed. Ut venenatis tellus in metus vulputate eu scelerisque. Pellentesque diam volutpat commodo sed egestas egestas fringilla phasellus faucibus. Nibh tellus molestie nunc non blandit massa enim nec.
              </p>
            </div>
          </li>

        </ul>

      </div>
    </section> */}


    {/* <section id="contact" className="contact section-bg">
      <div className="container">

        <div className="section-title" data-aos="fade-up">
          <h2>Contact Us</h2>
        </div>

        <div className="row">

          <div className="col-lg-5 d-flex align-items-stretch" data-aos="fade-right">
            <div className="info">
              <div className="address">
                <i className="icofont-google-map"></i>
                <h4>Location:</h4>
                <p>India</p>
              </div>

              <div className="email">
                <i className="icofont-envelope"></i>
                <h4>Email:</h4>
                <p> mensahq@mensaindia.org</p>
              </div>

              <div className="phone">
                <i className="icofont-phone"></i>
                <h4>Call:</h4>
                <p>+91 1234567890</p>
              </div>

              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3773.322760694227!2d72.82602007466247!3d18.961343055563013!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c91fceee827d%3A0xcf09380a83d03fc6!2smensa%20india%20(Mumbai)!5e0!3m2!1sen!2sin!4v1708667018224!5m2!1sen!2sin" frameBorder="0" style={{border:'0', width: '100%', height: '290px',    borderRadius:'20px',}} allowFullScreen></iframe>
            </div>

          </div>

          <div className="col-lg-7 mt-5 mt-lg-0 d-flex align-items-stretch" data-aos="fade-left">
            <form onSubmit={handleSubmit} method="post" role="form" className="php-email-form">
              <div className="form-row">
                <div className="form-group col-md-6">
                  <label htmlFor="name">Your Name</label>
                  <input type="text" name="name" className="form-control" id="name" data-rule="minlen:4" data-msg="Please enter at least 4 chars" />
                  <div className="validate"></div>
                </div>
                <div className="form-group col-md-6">
                  <label htmlFor="name">Phone Number</label>
                  <input type="tel" className="form-control" name="phone" id="phone" data-rule="phone" data-msg="Please enter a valid phone" />
                  <div className="validate"></div>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="name">Your Email</label>
                <input type="email" className="form-control" name="email" id="email" data-rule="email" data-msg="Please enter a valid email" />
                <div className="validate"></div>
              </div>
              <div className="form-group">
                <label htmlFor="name">Message</label>
                <textarea className="form-control" name="message" rows="1" data-rule="required" data-msg="Please write something for us"></textarea>
                <div className="validate"></div>
              </div>
              <div className="mb-3">
                <div className="loading">Loading</div>
                <div className="error-message"></div>
                <div className="sent-message">Your message has been sent. Thank you!</div>
              </div>
              <div className="text-center"><button type="submit">Send Message</button></div>
            </form>
          
          
          </div>

        </div>

      </div>
    </section> */}
    
  </main>
  
  </div>
  
  );
}

export default Home;
